import Recipe from './Recipe';
import { useAppSelector } from "../State/Store/hooks";
export default function Recipes() {
    // Récupération de la liste des recettes
    const recipes = useAppSelector((state) => state.recipes);
    return (<>
        {recipes.map((recipe, index) => <Recipe thisRecipe={recipe} indexOfRecipe={index} key={index}/>)}
    </>);
}
